<template>
  <div class="page page__has-bar">
    <div class="page__bd">
      <custom-layout class="weui-cells" :view-config="customViewConfig">
        <div class="weui-cell" slot="de_name">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.de_name || "项目名称"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="text"
              v-model="form.main.de_name"
              placeholder="请输入项目名称"
            />
          </div>
        </div>
        <customer-search-box
          slot="de_custname"
          :label="customLabel.de_custname || '需求来源'"
          placeholder="请输入或选择"
          v-model="form.main.de_custname"
          audit-status="UNAUDITED"
          @onchange="custChange"
          @select="onSelectCustomer"
        />
        <combo-search-box
          slot="de_product_type"
          :label="customLabel.de_product_type || '产品类型'"
          placeholder="请选择或输入产品类型"
          v-model="form.main.de_product_type"
          url="/api/plm/productType/getCombo"
          ref="combo1"
        />
        <div class="weui-cell" slot="de_cost">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.de_cost || "目标成本"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="number"
              v-model="form.main.de_cost"
              placeholder="请输入目标成本"
            />
          </div>
        </div>
        <div class="weui-cell" slot="de_annual_sales_plan">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.de_annual_sales_plan || "年销售计划"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="number"
              v-model="form.main.de_annual_sales_plan"
              placeholder="请输入年销售计划"
            />
          </div>
        </div>
        <div class="weui-cell" slot="de_sales_area">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.de_sales_area || "销售目标区域"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="text"
              v-model="form.main.de_sales_area"
              placeholder="请输入销售目标区域"
            />
          </div>
        </div>
        <div class="weui-cell" slot="de_sales_group">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.de_sales_group || "销售目标群体"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="text"
              v-model="form.main.de_sales_group"
              placeholder="请输入销售目标群体"
            />
          </div>
        </div>
        <employee-field
          :label="customLabel.de_emname || '需求人'"
          v-model="form.main.de_emname"
          @select="onSelectEmployee"
          slot="de_emname"
        />
        <div class="weui-cell" slot="de_describe">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.de_describe || "需求描述"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <textarea
              class="weui-textarea"
              placeholder="请输入"
              rows="3"
              v-model="form.main.de_describe"
              maxlength="300"
            ></textarea>
          </div>
        </div>
      </custom-layout>
      <div
        class="weui-cells__group"
        v-for="(item, xindex) in form.items"
        :key="xindex"
      >
        <div class="weui-cells__title">
          <span>配置需求{{ xindex + 1 }}</span>
          <a
            href="javascript:;"
            class="header-tool"
            @click="removeItem(xindex)"
          >
            <span>删除</span>
          </a>
        </div>
        <div class="weui-cells">
          <custom-layout :view-config="customViewConfig" position="detail1">
            <div class="weui-cell" slot="dd_name">
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.dd_name || "名称"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                <input
                  class="weui-input"
                  type="text"
                  v-model="item.dd_name"
                  placeholder="请填写"
                />
              </div>
            </div>
            <div class="weui-cell" slot="dd_spec">
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.dd_spec || "规格"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                <input
                  class="weui-input"
                  type="text"
                  v-model="item.dd_spec"
                  placeholder="请填写"
                />
              </div>
            </div>
            <div class="weui-cell" slot="dd_brand">
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.dd_brand || "品牌"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                <input
                  class="weui-input"
                  type="text"
                  v-model="item.dd_brand"
                  placeholder="请填写"
                />
              </div>
            </div>
            <div class="weui-cell" slot="dd_colour">
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.dd_colour || "颜色"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                <input
                  class="weui-input"
                  type="text"
                  v-model="item.dd_colour"
                  placeholder="请填写"
                />
              </div>
            </div>
            <div class="weui-cell" slot="dd_size">
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.dd_size || "尺寸"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                <input
                  class="weui-input"
                  type="text"
                  v-model="item.dd_size"
                  placeholder="请填写"
                />
              </div>
            </div>
            <div class="weui-cell" slot="dd_texture">
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.dd_texture || "材质"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                <input
                  class="weui-input"
                  type="text"
                  v-model="item.dd_texture"
                  placeholder="请填写"
                />
              </div>
            </div>
            <div class="weui-cell" slot="dd_silkscreen">
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.dd_silkscreen || "丝印"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                <input
                  class="weui-input"
                  type="text"
                  v-model="item.dd_silkscreen"
                  placeholder="请填写"
                />
              </div>
            </div>
            <div class="weui-cell" slot="dd_standard">
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.dd_standard || "标准"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                <input
                  class="weui-input"
                  type="text"
                  v-model="item.dd_standard"
                  placeholder="请填写"
                />
              </div>
            </div>
            <div class="weui-cell" slot="dd_remark">
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.dd_remark || "备注"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                <input
                  class="weui-input"
                  type="text"
                  v-model="item.dd_remark"
                  placeholder="请填写"
                />
              </div>
            </div>
            <custom-field
              :label="customLabel.dd_text1 || '自定义字段1'"
              v-model="item.dd_text1"
              :caller="caller"
              fieldName="dd_text1"
              slot="dd_text1"
              hidden="true"
            />
            <custom-field
              :label="customLabel.dd_text2 || '自定义字段2'"
              v-model="item.dd_text2"
              :caller="caller"
              fieldName="dd_text2"
              slot="dd_text2"
              hidden="true"
            />
            <custom-field
              :label="customLabel.dd_text3 || '自定义字段3'"
              v-model="item.dd_text3"
              :caller="caller"
              fieldName="dd_text3"
              slot="dd_text3"
              hidden="true"
            />
            <custom-field
              :label="customLabel.dd_text4 || '自定义字段4'"
              v-model="item.dd_text4"
              :caller="caller"
              fieldName="dd_text4"
              slot="dd_text4"
              hidden="true"
            />
            <custom-field
              :label="customLabel.dd_text5 || '自定义字段5'"
              v-model="item.dd_text5"
              :caller="caller"
              fieldName="dd_text5"
              slot="dd_text5"
              hidden="true"
            />
          </custom-layout>
          <a
            href="javascript:"
            class="weui-cell weui-cell_link"
            @click="addItem"
          >
            <div class="weui-cell__bd">添加更多</div>
          </a>
        </div>
      </div>

      <div class="weui-cells__group">
        <div class="weui-cells">
          <file-field v-model="form.main.de_attach" />
        </div>
      </div>
    </div>

    <div class="footer-bar weui-dialog__ft">
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="save"
        >提交</a
      >
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="$router.back()"
        >取消</a
      >
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import EmployeeField from "@/components/field/EmployeeField.vue";
import CustomerSearchBox from "@/components/field/CustomerSearchBox.vue";
import FileField from "@/components/field/FileField.vue";
import process from "@/mixins/process.js";
import ComboSearchBox from "@/components/field/ComboSearchBox.vue";
import CustomField from "@/components/field/CustomField.vue";

export default {
  components: {
    CustomLayout,
    EmployeeField,
    CustomerSearchBox,
    FileField,
    ComboSearchBox,
    CustomField,
  },
  mixins: [process],
  data() {
    return {
      baseUrl: "/api/plm/demand",
      codeField: "de_code",
      statusField: "de_statuscode",
      caller: "Demand",
      xtype: "plm-demand-formpanel",
      form: {
        main: {
          de_name: null,
          de_custname: null,
          de_product_type: null,
        },
        items: [
          {
            dd_name: null,
            dd_spec: null,
            dd_brand: null,
            dd_colour: null,
            dd_size: null,
            dd_texture: null,
            dd_silkscreen: null,
            dd_standard: null,
          },
        ],
      },
    };
  },
  methods: {
     /* 
      手动输入客户时置空id和code
    */
    custChange() {
      var me = this,
        main = me.form.main;
      main.de_custid = null;
      main.de_custcode = null;
    },
    onSelectCustomer(selection) {
      var me = this,
        main = me.form.main;
      main.de_custname = selection.cu_name;
      main.de_custid = selection.id;
      main.de_custcode = selection.cu_code;
    },
    onSelectEmployee(selection) {
      var me = this,
        main = me.form.main;
      main.de_emid = selection.id;
      main.de_emcode = selection.em_code;
      main.de_dpid = selection.em_dpid;
      main.de_dpcode = selection.dp_code;
      main.de_dpname = selection.dp_name;
    },

    type_combo_save(type) {
      var me = this;
      let combo1 = me.$refs.combo1.data,
        save = combo1.some((item) => {
          return item.value == type;
        });
      if (!save) {
        me.$ajax({
          url: "/api/plm/productType/save",
          method: "POST",
          jsonData: {
            name: type,
            id: 0,
          },
        }).then();
      }
    },
    /**
     * 保存
     */
    save() {
      var me = this,
        main = me.form.main,
        items = me.form.items;
      if (!main.de_name) {
        me.$weui.topTips("请输入项目名称", 2000);
      } else if (!main.de_custname) {
        me.$weui.topTips("请选择需求来源", 2000);
      } else if (!main.de_product_type) {
        me.$weui.topTips("请填写或选择产品类型", 2000);
      } else {
        me.form.main.de_product_type &&
          me.type_combo_save(me.form.main.de_product_type);

        var count = 0;
        items.forEach(function (item) {
          count++;
          item.dd_detno = count;
        });
        me.p_save();
      }
    },
    /**
     * 删除行
     */
    removeItem(index) {
      var me = this,
        items = me.form.items;
      if (items.length == 1) {
        me.$weui.topTips("请至少保留一行", 2000);
      } else {
        items.splice(index, 1);
      }
    },
    /**
     * 新增行
     */
    addItem() {
      var me = this,
        items = me.form.items;
      items.push({
        dd_name: null,
        dd_spec: null,
        dd_brand: null,
        dd_colour: null,
        dd_size: null,
        dd_texture: null,
        dd_silkscreen: null,
        dd_standard: null,
        dd_remark: null,
      });
    },
  },
};
</script>